import React, { Component } from 'react'
import { Form, Icon, Input, Button, Checkbox, message } from 'antd'
import styled from 'styled-components'
import md5 from 'blueimp-md5'
import axios from 'axios'
import { apiUtil as Util } from '../../mock/mockServices';
const FormItem = Form.Item

class Login extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        Reflect.deleteProperty(axios.defaults.headers, 'token')
        let pms = { ...values }
        pms.password = localStorage.loginPassword===values.password ?  localStorage.loginPassword : md5(values.password)
        Util.ajax.post('/common/login', pms)
          .then(res => {
            console.log(res)
            // Check for error codes in response
            // Real API returns {code, message} directly, mock API wraps in {data: {...}}
            const responseData = res.data || res
            if (responseData && responseData.code && responseData.code !== '0' && responseData.code !== 0) {
              // Login failed - show error message
              message.error(responseData.message || 'Login failed!')
              return
            }
            if (!responseData.hasLogin) {
              // 保存登录信息
              if(pms.sureLogin) {
                localStorage.setItem('loginUsername', pms.loginName)
                localStorage.setItem('loginPassword', pms.password)
              }
              // this.props.store.setUserInfo(res.data)
              localStorage.setItem('authToken', responseData.token)
              localStorage.setItem('authUserName', responseData.userName)
              localStorage.setItem('authUserId', responseData.userId)
              localStorage.setItem('authLoginName', md5(responseData.loginName))
              localStorage.setItem('authRoleList', responseData.roleList)
              localStorage.setItem('authOrgId', responseData.orgId)
              localStorage.setItem('authTrainState', responseData.trainState)
            }
            if (responseData.trainState === '0'){
              window.location.href='/train'
            } else {
              window.location.href='/predict'
            }
          })
          .catch(err => {
            console.error('Login error:', err)
            message.error('Login failed! Please check your network connection.')
          })
      }
    })
  }
  componentDidMount() {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUserName')
    localStorage.removeItem('authUserId')
    localStorage.removeItem('authLoginName')
    localStorage.removeItem('dwconfiged')
    localStorage.removeItem('authRoleList')
    localStorage.removeItem('authOrgId')
    localStorage.removeItem('authTrainState')

    if(localStorage.loginUsername && localStorage.loginPassword) {
      this.props.form.setFieldsValue({
        loginName: localStorage.loginUsername,
        password:localStorage.loginPassword
      })
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    return (
      <Root>
        <div className="login-page">
          <div className="login-box">
            <div className="title"><i className="iconfont">&#xe61c;</i>G.E.T Algo System</div>
            <Form
              onSubmit={this.handleSubmit}
              className="login-form">
              <FormItem>
                {getFieldDecorator('loginName', {
                  rules: [ { required: true, message: 'Please enter your username!' } ]
                })(
                  <Input
                    addonBefore={
                      <Icon type="user" style={{ color: 'rgba(0,0,0,.45)' }} />
                    }
                    placeholder="Username"
                  />
                )}
              </FormItem>
              <FormItem className="mb10">
                {getFieldDecorator('password', {
                  rules: [ { required: true, message: 'Please enter your password!' } ]
                })(
                  <Input
                    addonBefore={ <Icon type="lock" style={{ color: 'rgba(0,0,0,.45)' }} /> }
                    type="password"
                    placeholder="Password"
                  />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('sureLogin', {
                 valuePropName:'checked',
                 initialValue: true
                })(
                  <Checkbox>Remember me</Checkbox>
                )}
              </FormItem>
              <FormItem>
                <Button type="primary" htmlType="submit" className="login-form-button"> Log in </Button>
              </FormItem>
            </Form>
            <div className="copyright">
              Copyright©2025 G.E.T Algo System
            </div>
          </div>
        </div>
      </Root>
    )
  }
}
const LoginForm = Form.create({ name: 'login' })(Login)
export default LoginForm

const Root = styled.div`
    .login-page {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(238,238,238, 1);
    }
    .login-box {
      padding: 15px 40px;
      border:solid 1px #ccc;
      border-radius:2px;
      box-shadow: 0 0 3px #ccc;
      background: #fff;
        width: 360px;
    }
    .title {
        margin: 0px auto 40px auto;
        padding-top: 25px;
        color: #666;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        .iconfont{
          margin-right: 10px;
          color:#40a9ff;
          font-size: 30px;
          position: relative;
          bottom: -4px;
        }
    }
    .login-form-button {
        width: 100%;
    }
    .copyright {
      text-align: center;
      font-size: 12px;
      color: #999;
      padding: 20px 0;
    }
`
